// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1apMX","image":"App_image__O-euW"};